<template>
	<div>
		<p class="item">调度配置：</p>
		<Row :gutter="20">
			<Col span="12">
				<ul class="item">
					<li class="item">
						<label :class="{
							active: focus == 'minute'
						}">分钟</label>
						<Input
							style="width: 60%;"
							placeholder="分钟"
							v-model="minute"
							@on-focus="handleFocus('minute')"
						/>
					</li>
					<li class="item">
						<label :class="{
							active: focus == 'hour'
						}">小时</label>
						<Input
							style="width: 60%;"
							placeholder="小时"
							v-model="hour"
							@on-focus="handleFocus('hour')"
						/>
					</li>
					<li class="item">
						<label :class="{
							active: focus == 'date'
						}">日</label>
						<Input
							style="width: 60%;"
							placeholder="日"
							v-model="date"
							@on-focus="handleFocus('date')"
						/>
					</li>
					<li class="item">
						<label :class="{
							active: focus == 'month'
						}">月</label>
						<Input
							style="width: 60%;"
							placeholder="月"
							v-model="month"
							@on-focus="handleFocus('month')"
						/>
					</li>
					<li>
						<label :class="{
							active: focus == 'day'
						}">周</label>
						<Input
							style="width: 60%;"
							placeholder="周"
							v-model="day"
							@on-focus="handleFocus('day')"
						/>
					</li>
				</ul>
			</Col>
			<Col span="12">
				<div class="container">
					<h5 class="item">Special Characters:</h5>
					<ul>
						<li class="item">
							<mark>*</mark>
							&nbsp;
							any value
						</li>
						<li class="item">
							<mark>,</mark>
							&nbsp;
							value list separators
						</li>
						<li class="item">
							<mark>-</mark>
							&nbsp;
							range of values
						</li>
						<li class="item">
							<mark>/</mark>
							&nbsp;
							step values
						</li>
						<li class="item" v-if="focus == 'day'">
							<mark>1 - 7</mark>
							&nbsp;
							SUN MON TUE WED THU FRI SAT
						</li>
						<li class="item" v-else-if="focus != ''">
							<mark v-if="focus == 'minute'">0 - 59</mark>
							<mark v-else-if="focus == 'hour'">0 - 23</mark>
							<mark v-else-if="focus == 'date'">1 - 31</mark>
							<mark v-else-if="focus == 'month'">1 - 12</mark>
							&nbsp;
							allowed values
						</li>
						<li class="item" v-if="focus == 'date' || focus == 'day'">
							<mark>?</mark>
							&nbsp;
							Blank
						</li>
					</ul>
				</div>
			</Col>
		</Row>
		<p class="item">CRONTAB表达式</p>
		<Input
			type="text"
			style="width: 60%;"
			:value="cronOutput"
			readonly
		/>
		<Button
			type="info"
			ghost
			@click="handlePreview"
		>
			预览
		</Button>
		<Button
			type="warning"
			ghost
			@click="handleReset"
		>
			重置
		</Button>
	</div>
</template>

<script>
	import moment from "moment";
	import 'moment/locale/zh-cn';
	
	import parser from "cron-parser";
	
	import {isValidCron} from "cron-validator";
	
	export default {
		props: {
			currentCron: {
				type: String,
				default: "0 * * ? * *"
			}
		},
		data() {
			return {
				focus: "",
				weeks: {
					"1": "日",
					"2": "一",
					"3": "二",
					"4": "三",
					"5": "四",
					"6": "五",
					"7": "六"
				},
				minute: "*",
				hour: "*",
				date: "?",
				month: "*",
				day: "*"
			};
		},
		watch: {
			cronOutput(newValue, oldValue) {
				this.$emit("change-cron", newValue);
			}
		},
		computed: {
			cronOutput() {
				let {
					minute = "*",
					hour = "*",
					date = "?",
					month = "*",
					day = "*"
				} = this;
				
				return `0 ${minute} ${hour} ${date} ${month} ${day}`;
			}
		},
		methods: {
			handleFocus(name) {
				this.focus = name;
			},
			handleReset() {
				this.hour = this.minute = this.day = this.month = "*";
				
				this.date = "?";
				
				this.focus = "";
			},
			updateCron(value) {
				let [
					second,
					minute,
					hour,
					date,
					month,
					day
				] = value.split(" ");
				
				this.minute = minute;
				this.hour = hour;
				this.date = date;
				this.month = month;
				this.day = day;
			},
			handlePreview() {
				let cronOutput = this.cronOutput.split(" ");
				
				let dayOfWeek = cronOutput[cronOutput.length - 1];
				
				if(!isNaN(dayOfWeek)) {
					cronOutput[cronOutput.length - 1] = dayOfWeek - 1;
				}
				
				cronOutput = cronOutput.join(" ");
				
				if(!isValidCron(cronOutput, {
					seconds: true,
					allowBlankDay: true
				})) {
					return this.$Message.warning("请检查表达式的合法性");
				}
				
				let interval = parser.parseExpression(cronOutput, {
					tz: 'Asia/Shanghai',
					iterator: true
				});
				
				let list = "";
				
				for(let i = 0; i < 10; i++) {
					let object = interval.next();
					
					list += `<li>${object.value._date.format("YYYY-MM-DD HH:mm:ss")}</li>`;
					
					if(object.done) {
						break;
					}
				}
				
				this.$Modal.info({
					title: "Next 10 scheduled executions:",
					content: `<ul>${list}</ul>`
				});
			}
		}
	};
</script>

<style scoped>
	label {
		display: inline-block;
		width: 35%;
	}
	
	.active {
		color: #2b85e4;
	}
</style>
